import { useState } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';

export const TimecardUnapprovalModal = ({
  open,
  onClose,
  onUnapprove,
  weekEndingDate,
  foremanName, // Optional: for admin unapproval on behalf
}) => {
  const [reason, setReason] = useState('');

  const formatDate = (dateString) => {
    if (!dateString) return '';
    try {
      const date = new Date(dateString);
      return date.toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
      });
    } catch (error) {
      return dateString;
    }
  };

  const handleClose = () => {
    setReason('');
    onClose();
  };

  const handleUnapprove = () => {
    onUnapprove(reason);
    setReason('');
  };

  // Determine if this is an admin unapproval on behalf
  const isAdminUnapproval = !!foremanName;

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        {isAdminUnapproval
          ? `Unapprove Time on Behalf of ${foremanName}`
          : `Unapprove Time for Week Ending ${formatDate(weekEndingDate)}`}
      </DialogTitle>
      <DialogContent>
        <Typography variant="body1" paragraph>
          {isAdminUnapproval
            ? `This will unlock ${foremanName}'s timecards for the week ending ${formatDate(weekEndingDate)}.`
            : 'This will unlock your timecards for editing.'}
        </Typography>

        <Box sx={{ mt: 2 }}>
          <TextField
            fullWidth
            multiline
            rows={4}
            label="Reason for unapproval (optional)"
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            placeholder="Enter reason for unapproval..."
            variant="outlined"
          />
        </Box>
      </DialogContent>
      <DialogActions sx={{ p: 2 }}>
        <Button onClick={handleClose} variant="outlined" sx={{ minWidth: 120 }}>
          Cancel
        </Button>
        <Button
          onClick={handleUnapprove}
          variant="contained"
          color="primary"
          sx={{ minWidth: 120 }}
        >
          Unapprove Week
        </Button>
      </DialogActions>
    </Dialog>
  );
};
